import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AlertService, AlertType } from 'src/app/shared/services/alert.service';
import { AnswerService } from 'src/app/shared/services/API/self-triage/answer.service';

@Component({
  selector: 'app-answer-delete-modal',
  templateUrl: './answer-delete-modal.component.html',
  styleUrls: ['./answer-delete-modal.component.css']
})
export class AnswerDeleteModalComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, 
    public dialog: MatDialog, 
    public matDialogRef: MatDialogRef<AnswerDeleteModalComponent>,
    private answerService: AnswerService,
    private alertService: AlertService,
  ) { }

  public isLoading:boolean;  

  ngOnInit(): void {
    this.isLoading = false;
  }
  
  close(){
    this.matDialogRef.close({deleteAnswer: false}); 
  }
  
  clickDelete(){
    
    this.isLoading = true;

    this.answerService.deleteAnswer(this.data.idAnswer).subscribe((response)=>{
      
      if(response.isError){
        this.alertService.show('Erro', response.errorDescription, AlertType.error);
        this.isLoading = false;
        return;
      }
      
      this.alertService.show('Sucesso', "Resposta excluido com sucesso!", AlertType.success); 
      this.matDialogRef.close({deleteAnswer: true}); 
    },
    (error)=>{
      console.log(error)
      this.isLoading = false;
      this.alertService.show('Erro inesperado', error, AlertType.error);
    });
  }
  
  clickCancel(){
    this.matDialogRef.close({deleteAnswer: false}); 
  }
}